// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const PreferredTheme = t.struct({
    allowedPreferredThemes: t.Array,
    key: t.String,
    value: t.String
}, {
    name: 'PreferredTheme',
    strict: true
});

export const getDefaultState = () => new PreferredTheme({
    allowedPreferredThemes: [],
    key: '',
    value: ''
});

export default PreferredTheme;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/preferred-theme.js